// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: end_function.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { ErrorsUpdate, FunctionError, FunctionParameter } from "./functions";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "end_function";

export interface EndFunctionReferences {
  variables: { [key: string]: boolean };
}

export interface EndFunctionReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface EndFunction {
  id: string;
  name: string;
  description: string;
  parameters: FunctionParameter[];
  code: string;
  errors: FunctionError[];
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  archived: boolean;
  references: EndFunctionReferences | undefined;
}

export interface EndFunctionCreate {
  id: string;
  name: string;
  description: string;
  parameters: FunctionParameter[];
  code: string;
  errors: FunctionError[];
  archived?: boolean | undefined;
  references?: EndFunctionReferences | undefined;
}

export interface EndFunctionDelete {
  id: string;
}

export interface EndFunctionUpdate {
  id: string;
  description?: string | undefined;
  code?: string | undefined;
  errors?: ErrorsUpdate | undefined;
  references?: EndFunctionReferences | undefined;
}

function createBaseEndFunctionReferences(): EndFunctionReferences {
  return { variables: {} };
}

export const EndFunctionReferences: MessageFns<EndFunctionReferences> = {
  encode(message: EndFunctionReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      EndFunctionReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EndFunctionReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEndFunctionReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = EndFunctionReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.variables[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EndFunctionReferences {
    return {
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: EndFunctionReferences): unknown {
    const obj: any = {};
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<EndFunctionReferences>): EndFunctionReferences {
    return EndFunctionReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EndFunctionReferences>): EndFunctionReferences {
    const message = createBaseEndFunctionReferences();
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseEndFunctionReferences_VariablesEntry(): EndFunctionReferences_VariablesEntry {
  return { key: "", value: false };
}

export const EndFunctionReferences_VariablesEntry: MessageFns<EndFunctionReferences_VariablesEntry> = {
  encode(message: EndFunctionReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EndFunctionReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEndFunctionReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EndFunctionReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: EndFunctionReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<EndFunctionReferences_VariablesEntry>): EndFunctionReferences_VariablesEntry {
    return EndFunctionReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EndFunctionReferences_VariablesEntry>): EndFunctionReferences_VariablesEntry {
    const message = createBaseEndFunctionReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseEndFunction(): EndFunction {
  return {
    id: "",
    name: "",
    description: "",
    parameters: [],
    code: "",
    errors: [],
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    archived: false,
    references: undefined,
  };
}

export const EndFunction: MessageFns<EndFunction> = {
  encode(message: EndFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.parameters) {
      FunctionParameter.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.code !== "") {
      writer.uint32(42).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(66).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(74).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(82).string(message.updatedBy);
    }
    if (message.archived !== false) {
      writer.uint32(88).bool(message.archived);
    }
    if (message.references !== undefined) {
      EndFunctionReferences.encode(message.references, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EndFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEndFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters.push(FunctionParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.references = EndFunctionReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EndFunction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FunctionParameter.fromJSON(e))
        : [],
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
      references: isSet(object.references) ? EndFunctionReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: EndFunction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FunctionParameter.toJSON(e));
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    if (message.references !== undefined) {
      obj.references = EndFunctionReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<EndFunction>): EndFunction {
    return EndFunction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EndFunction>): EndFunction {
    const message = createBaseEndFunction();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.parameters = object.parameters?.map((e) => FunctionParameter.fromPartial(e)) || [];
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.archived = object.archived ?? false;
    message.references = (object.references !== undefined && object.references !== null)
      ? EndFunctionReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseEndFunctionCreate(): EndFunctionCreate {
  return {
    id: "",
    name: "",
    description: "",
    parameters: [],
    code: "",
    errors: [],
    archived: undefined,
    references: undefined,
  };
}

export const EndFunctionCreate: MessageFns<EndFunctionCreate> = {
  encode(message: EndFunctionCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.parameters) {
      FunctionParameter.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.code !== "") {
      writer.uint32(42).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.archived !== undefined) {
      writer.uint32(56).bool(message.archived);
    }
    if (message.references !== undefined) {
      EndFunctionReferences.encode(message.references, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EndFunctionCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEndFunctionCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters.push(FunctionParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.references = EndFunctionReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EndFunctionCreate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FunctionParameter.fromJSON(e))
        : [],
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : undefined,
      references: isSet(object.references) ? EndFunctionReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: EndFunctionCreate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FunctionParameter.toJSON(e));
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.archived !== undefined) {
      obj.archived = message.archived;
    }
    if (message.references !== undefined) {
      obj.references = EndFunctionReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<EndFunctionCreate>): EndFunctionCreate {
    return EndFunctionCreate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EndFunctionCreate>): EndFunctionCreate {
    const message = createBaseEndFunctionCreate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.parameters = object.parameters?.map((e) => FunctionParameter.fromPartial(e)) || [];
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.archived = object.archived ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? EndFunctionReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseEndFunctionDelete(): EndFunctionDelete {
  return { id: "" };
}

export const EndFunctionDelete: MessageFns<EndFunctionDelete> = {
  encode(message: EndFunctionDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EndFunctionDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEndFunctionDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EndFunctionDelete {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: EndFunctionDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<EndFunctionDelete>): EndFunctionDelete {
    return EndFunctionDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EndFunctionDelete>): EndFunctionDelete {
    const message = createBaseEndFunctionDelete();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseEndFunctionUpdate(): EndFunctionUpdate {
  return { id: "", description: undefined, code: undefined, errors: undefined, references: undefined };
}

export const EndFunctionUpdate: MessageFns<EndFunctionUpdate> = {
  encode(message: EndFunctionUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.code !== undefined) {
      writer.uint32(26).string(message.code);
    }
    if (message.errors !== undefined) {
      ErrorsUpdate.encode(message.errors, writer.uint32(34).fork()).join();
    }
    if (message.references !== undefined) {
      EndFunctionReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EndFunctionUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEndFunctionUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.errors = ErrorsUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = EndFunctionReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EndFunctionUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      code: isSet(object.code) ? globalThis.String(object.code) : undefined,
      errors: isSet(object.errors) ? ErrorsUpdate.fromJSON(object.errors) : undefined,
      references: isSet(object.references) ? EndFunctionReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: EndFunctionUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.code !== undefined) {
      obj.code = message.code;
    }
    if (message.errors !== undefined) {
      obj.errors = ErrorsUpdate.toJSON(message.errors);
    }
    if (message.references !== undefined) {
      obj.references = EndFunctionReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<EndFunctionUpdate>): EndFunctionUpdate {
    return EndFunctionUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EndFunctionUpdate>): EndFunctionUpdate {
    const message = createBaseEndFunctionUpdate();
    message.id = object.id ?? "";
    message.description = object.description ?? undefined;
    message.code = object.code ?? undefined;
    message.errors = (object.errors !== undefined && object.errors !== null)
      ? ErrorsUpdate.fromPartial(object.errors)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? EndFunctionReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
